import React from 'react';
import { Separator } from '@/components/ui/separator';
import { MapPin, FileText, Settings } from 'lucide-react';

export const Footer = ({ t, onAdminClick }) => {
  const footer = t.footer;

  return (
    <footer className="bg-card border-t border-border mt-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col items-center text-center space-y-4">
          {/* Company Name */}
          <div className="flex items-center gap-2">
            <span className="font-bold text-foreground">{footer.company}</span>
          </div>

          <Separator className="w-32" />

          {/* Company Details */}
          <div className="space-y-2 text-sm text-muted-foreground">
            <div className="flex items-center justify-center gap-2">
              <MapPin className="w-4 h-4" />
              <span>{footer.address}</span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <div className="flex items-center gap-1">
                <FileText className="w-4 h-4" />
                <span><strong>Handelsregisternummer:</strong> HRB 260515 B</span>
              </div>
              <div className="flex items-center gap-1">
                <span><strong>Ust-IdNr:</strong> DE369471524</span>
              </div>
            </div>
            <p className="text-xs">
              <strong>Steuernummer:</strong> 27/490/50646
            </p>
          </div>

          {/* Copyright and Admin */}
          <div className="flex items-center justify-center gap-4 pt-4">
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} RenewBee GmbH. All rights reserved.
            </p>
            <button
              onClick={onAdminClick}
              className="text-muted-foreground/50 hover:text-muted-foreground transition-colors p-1 rounded"
              title="Admin"
              aria-label="Admin Panel"
            >
              <Settings className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
